import * as action from './accountAction'
import { default as actionType } from './accountActionType'
import { default as reducer } from './accountReducer'

export const ACCOUNT = {
  action,
  actionType,
  reducer
}
